import { useMemo } from "react";
import { ReportQueriesEntity } from "../domain/reportQueries.entity";
import { dtoToEntity } from "./reportQueries.dto";
import {
  GetReportQueriesRequest,
  GetReportQueriesResponse,
} from "../../../gen/witbooking/backoffice/reportqueries/v1/reportqueries_api_pb";
import { GrpcCall } from "../../../lib/grpc";
import { dateStringToProtoTimestamp } from "../../../lib/dateUtils";

export interface ReportQueriesRequest {
  startDate: string;
  endDate: string;
}

export interface GetReportQueriesRequestProps {
  request: ReportQueriesRequest;
  size: number;
  page: number;
}

export interface ReportQueriesResponse {
  report: ReportQueriesEntity[];
  totalResults: number;
}

async function getQueriesReport({
  request,
  grpcCall,
  size,
  page,
}: GetReportQueriesRequestProps & {
  grpcCall: GrpcCall<void, GetReportQueriesRequest, GetReportQueriesResponse>;
}): Promise<ReportQueriesResponse> {
  const grpcRequest: GetReportQueriesRequest = new GetReportQueriesRequest();
  grpcRequest.setStartDate(dateStringToProtoTimestamp(request.startDate));
  grpcRequest.setEndDate(dateStringToProtoTimestamp(request.endDate));
  grpcRequest.setPage(page + 1);
  grpcRequest.setSize(size);
  const response: GetReportQueriesResponse = await grpcCall(grpcRequest);
  const report = response.getReportList();
  const totalResults = response.getTotalResults();
  return {
    report: dtoToEntity(report),
    totalResults,
  };
}

export const useReportQueriesApi = (
  grpcCall: GrpcCall<void, GetReportQueriesRequest, GetReportQueriesResponse>
) => {
  return useMemo(
    () => ({
      getQueriesReport: (props: GetReportQueriesRequestProps) =>
        getQueriesReport({ grpcCall, ...props }),
    }),
    [grpcCall]
  );
};
